const o = "_chevron_9ku18_14", e = "_open_9ku18_33", n = {
  chevron: o,
  open: e
};
export {
  o as chevron,
  n as default,
  e as open
};
//# sourceMappingURL=chevron.module.less.js.map
